import React, { useState, useEffect } from "react";
import axios from "axios";
import { Carousel, Col, Container, Row } from "react-bootstrap";

const BrideImage = ({ src }) => (
  <div
    style={{
      width: "100%",
      aspectRatio: "3 / 4",
      overflow: "hidden",
      borderRadius: "4px",
    }}
  >
    <img
      className="d-block"
      src={src}
      alt="Bride"
      style={{ width: "100%", height: "100%", objectFit: "cover" }}
    />
  </div>
);

const Bride = () => {
  const [brides, setBrides] = useState([]);
  const [loading, setLoading] = useState(false);

  const getAllBrides = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/api/bride/getAll");
      const all = response.data?.brides || [];
      // featured first, then the rest, both sorted by most recent
      const featured = all
        .filter((b) => b.setAsFeatured === true)
        .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      const nonFeatured = all
        .filter((b) => b.setAsFeatured !== true)
        .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      setBrides(featured.concat(nonFeatured));
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getAllBrides();
  }, []);

  return (
    <div style={{ marginTop: "-1.0rem", marginBottom: "1rem" }}>
      <span className="title">Brides of Jatin Mor Jewels</span>

      <Container style={{ marginTop: "0rem" }}>
        <Row style={{ margin: "0rem 1rem" }}>
          {loading && !brides.length && (
            <div className="d-flex justify-content-center mt-5">
              <div className="spinner-border" role="status">
                <span className="sr-only"></span>
              </div>
            </div>
          )}
          {!loading && !brides.length && (
            <div className="d-flex justify-content-center">
              <h4>No Brides Found</h4>
            </div>
          )}
          {brides.length > 0 && (
            <Col>
              <Carousel>
                {brides.map((bride, index) => (
                  <Carousel.Item interval={3000} key={bride._id || index}>
                    <Row>
                      <Col xs={12} md={4}>
                        <BrideImage src={bride.image[0]?.url} />
                      </Col>
                      <Col xs={12} md={4} className="d-none d-md-block">
                        <BrideImage
                          src={brides[(index + 1) % brides.length]?.image[0]?.url}
                        />
                      </Col>
                      <Col xs={12} md={4} className="d-none d-md-block">
                        <BrideImage
                          src={brides[(index + 2) % brides.length]?.image[0]?.url}
                        />
                      </Col>
                    </Row>
                  </Carousel.Item>
                ))}
              </Carousel>
            </Col>
          )}
        </Row>
      </Container>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <a href="/videocall">
          <p className="collectionTitle" style={{ fontSize: "clamp(12px, 3vw, 26px)" }}>
            Book a consultation with our experts for a bespoke collection that
            complements <br className="br" /> the essence of your unique
            celebration.
          </p>
        </a>
      </div>
    </div>
  );
};

export default Bride;
